/**
 * 将字符串内容转为一个 Blob 对象
 * @param content 字符串内容
 * @param fileName 命名
 * @param contentType 内容类型，默认为纯文本，即 "text/plain;charset=utf-8"
 * @param charset 字符集，默认 utf-8
 */
export const stringToBlob = (content: string, fileName: string, contentType = "text/plain", charset= "utf-8") => {
	return new Blob([content],{
		type: `${contentType};charset=${charset}`
	})
}
